import { JsonObject, JsonProperty } from 'json2typescript';
import { OperativeModelPortfolioResponseInterface } from '../interfaces/modelportfolio.interface';

@JsonObject('OperativeModelPortfolioResponseModel')
export class OperativeModelPortfolioResponseModel
  implements OperativeModelPortfolioResponseInterface
{
  @JsonProperty('InitialContribution', Number, true)
  initialContribution: number = undefined;

  @JsonProperty('MinimumContribution', Number, true)
  minimumContribution: number = undefined;

  @JsonProperty('MinimumWithdrawal', Number, true)
  minimumWithdrawal: number = undefined;

  @JsonProperty('MinimumInvest', Number, true)
  minimumInvest: number = undefined;

  @JsonProperty('BaseCurrency', String, true)
  baseCurrency: string = undefined;
}
